<template>
  <div class="content">
    <!-- 投票详情 -->

    <!-- 投票议案 -->
    <Alert type="success" show-icon>
      投票组织：{{ voteOrgId }}
      <template #icon>
        <Icon type="ios-information-circle-outline"></Icon>
      </template>
    </Alert>

    <Divider orientation="left" size="small">投票议案</Divider>
    <Card dis-hover>
      <DescriptionList :col="1">
        <Description term="投票事件：">{{
          this.voteInfo.voteName
        }}</Description>
        <Description term="所在链ID：">{{
          voteInfo.formatChainId
        }}</Description>
        <Description term="发起组织：">{{
          this.voteInfo.startOrgId
        }}</Description>
      </DescriptionList>
      <DescriptionList :col="3">
        <Description term="投票状态：">{{
          this.voteInfo.orgVoteStatusFormat
        }}</Description>
        <Description term="投票结果：">{{
          this.voteInfo.voteResultFormat
        }}</Description>
        <Description term="多签状态：">{{
          this.voteInfo.multiStatusFormat
            ? this.voteInfo.multiStatusFormat
            : "-"
        }}</Description>
      </DescriptionList>
      <DescriptionList :col="1">
        <Description term="议案详情：">{{
          this.voteInfo.voteDetail
        }}</Description>
        <Description term="投票原因：" v-if="this.voteInfo.reason">{{
          this.voteInfo.reason
        }}</Description>
      </DescriptionList>
    </Card>
    <Divider style="margin-top: 20px" orientation="left" size="small"
      >投票情况</Divider
    >
    <!-- 投票情况 -->
    <Card dis-hover>
      <DescriptionList :col="2" v-if="this.voteInfo.policyRule">
        <Description term="投票规则：">{{
          this.voteInfo.policyRule
        }}</Description>
      </DescriptionList>
      <DescriptionList :col="2">
        <Description term="投同意票：">{{
          this.voteInfo.agreeOrgList && this.voteInfo.agreeOrgList.length > 0
            ? this.voteInfo.agreeOrgList.join()
            : ""
        }}</Description>
        <Description term="同意比例：">{{
          this.voteInfo.agreeRate
        }}</Description>
        <Description term="投反对票：">{{
          this.voteInfo.rejectOrgList && this.voteInfo.rejectOrgList.length > 0
            ? this.voteInfo.rejectOrgList.join()
            : "-"
        }}</Description>
        <Description term="反对比例：">{{
          this.voteInfo.rejectRate
        }}</Description>
        <Description term="未投票：">{{
          this.voteInfo.notVoteOrgList &&
          this.voteInfo.notVoteOrgList.length > 0
            ? this.voteInfo.notVoteOrgList.join()
            : "-"
        }}</Description>
        <Description term="未投票比例：">{{
          this.voteInfo.notVoteRate
        }}</Description>
      </DescriptionList>
    </Card>
    <!-- 操作 -->
    <div style="margin: 30px 0">
      <ButtonGroup>
        <Button
          type="primary"
          ghost
          v-if="
            this.voteInfo.orgVoteStatus == 'undo' &&
            this.voteInfo.voteResult != 'pass' &&
            this.voteInfo.multiStatus != 'success'
          "
          @click="voteDrawer"
          >投票</Button
        >
        <!-- <Button type="primary" ghost @click="voteDrawer">投票</Button> -->
        <Button
          type="primary"
          ghost
          @click="multiSign"
          v-if="
            this.voteInfo.voteResult == 'pass' &&
            this.voteInfo.multiStatus != 'success'
          "
          >多签</Button
        >
      </ButtonGroup>
    </div>

    <!-- 对话框 - 投票 -->
    <Modal
      v-model="isShowVoteDrawer"
      title="投票"
      ok-text="投票"
      @on-ok="voteOk"
    >
      <DescriptionList :col="1">
        <Description term="投票事件：">{{
          this.voteInfo.voteName
        }}</Description>
      </DescriptionList>
      <Form ref="xForm" :model="formData" :rules="formRules" :label-width="80">
        <Row>
          <Col :span="20">
            <FormItem label="投票状态" prop="voteStatus">
              <Select v-model="formData.voteStatus" clearable>
                <Option
                  v-for="item in voteStatusList"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  </div>
</template>

<script>
// 接口
import { GetVoteDetail, Vote, MultiSign } from "@/api/chain.js";
import { mapState } from "vuex";

export default {
  data() {
    return {
      formData: {
        voteStatus: "",
      },
      formRules: {
        voteStatus: [{ required: true, message: "请选择" }],
      },
      voteStatusList: [
        {
          label: "同意",
          value: "agree",
        },
        {
          label: "拒绝",
          value: "reject",
        },
      ],
      isShowVoteDrawer: false,
      voteOrgId: "",
      voteInfo: {},
      voteResultList: [
        // 投票结果格式化列表
        {
          label: "投票中",
          value: "doing",
        },
        {
          label: "投票通过",
          value: "pass",
        },
      ],

      orgVoteStatusList: [
        // 投票结果
        {
          label: "未投票",
          value: "undo",
        },
        {
          label: "同意",
          value: "agree",
        },
        {
          label: "反对",
          value: "reject",
        },
      ],
      multiStatusList: [
        // 多签状态
        {
          label: "成功",
          value: "success",
        },
        {
          label: "失败",
          value: "fail",
        },
      ],
    };
  },
  computed: {
    ...mapState("user", ["profile"]),
  },
  methods: {
    // 发起多签
    async multiSign() {
      this.$VXETable.modal
        .confirm({
          title: "多签确认",
          content: `是否进行多签操作`,
        })
        .then(async (type) => {
          if (type == "cancel" || type == "close") {
            this.$Message.info("取消了操作");
          } else if (type == "confirm") {
            let args = {
              voteId: this.voteInfo.voteId,
              chainId: this.voteInfo.chainId,
              voteType: this.voteInfo.voteType,
              voteOrgId: this.voteOrgId,
            };
            let res = await MultiSign(args);
            if (res && res.code == 200) {
              this.$Message.info("操作完成");
              // 刷新页面
              setTimeout(() => {
                this.refresh();
              }, 1000);
            }
          }
        });
    },
    formatChain({ chainId }) {
      // console.log(chainId);
    },
    voteDrawer() {
      this.$refs["xForm"].resetFields();
      this.isShowVoteDrawer = true;
    },
    async voteOk() {
      this.$refs["xForm"].validate(async (valid) => {
        if (valid) {
          // 投票
          let args = {
            chainId: this.voteInfo.chainId,
            orgId: this.voteOrgId,
            voteId: this.voteInfo.voteId,
            voteType: this.voteInfo.voteType,
            voteStatus: this.formData.voteStatus,
          };
          let res = await Vote(args);
          if (res && res.code == 200) {
            this.$Message.info("投票完成");
          }
          // 刷新数据
          this.refresh();
        }
      });
    },
    async refresh() {
      // console.log(this.voteInfo);
      // 获取投票详情
      let args = {
        orgId: this.voteOrgId,
        voteId: this.voteInfo.voteId,
      };
      // console.log(args);
      let res = await GetVoteDetail(args);
      if (res && res.code == 200) {
        let voteDetail = res.data;

        this.init(voteDetail, this.voteOrgId);
      }
    },
    init(voteDetail, voteOrgId) {
      // 投票状态
      if (voteDetail.orgVoteStatus) {
        voteDetail.orgVoteStatusFormat = this.formatOrgVoteStatus(
          voteDetail.orgVoteStatus
        );
      }
      // 投票结果
      if (voteDetail.voteResult) {
        voteDetail.voteResultFormat = this.formatVoteResult(
          voteDetail.voteResult
        );
      }
      // 多签状态
      if (voteDetail.multiStatus) {
        voteDetail.multiStatusFormat = this.formatMultiStatus(
          voteDetail.multiStatus
        );
      }

      if (voteDetail.chainId && voteDetail.chainId.includes("@")) {
        voteDetail.formatChainId = voteDetail.chainId.split("@")[0];
      } else {
        voteDetail.formatChainId = voteDetail.chainId;
      }

      this.voteInfo = voteDetail;
      this.voteOrgId = voteOrgId;
    },
    // 格式化投票结果
    formatVoteResult(cellValue) {
      let item = this.voteResultList.find((item) => item.value == cellValue);
      return item ? item.label : "-";
    },
    // 格式化组织投票状态
    formatOrgVoteStatus(cellValue) {
      let item = this.orgVoteStatusList.find((item) => item.value == cellValue);
      return item ? item.label : "-";
    },
    // 格式化多签状态
    formatMultiStatus(cellValue) {
      let item = this.multiStatusList.find((item) => item.value == cellValue);
      return item ? item.label : "-";
    },
  },
};
</script>
